export default "__VITE_ASSET__nPcX7F5j__"